import type { DropdownOption } from "../components/ui/form";

/**
 * Get the available language options for the language preference dropdown
 */
export function getLanguageOptions(): DropdownOption[] {
	return [
		{ value: "English", label: "English", flag: "🇬🇧" },
		{ value: "Spanish", label: "Spanish", flag: "🇪🇸" },
		{ value: "Hebrew", label: "Hebrew", flag: "🇮🇱" },
		{ value: "French", label: "French", flag: "🇫🇷" },
		{ value: "German", label: "German", flag: "🇩🇪" },
		{ value: "Hindi", label: "Hindi", flag: "🇮🇳" },
		{ value: "Italian", label: "Italian", flag: "🇮🇹" },
		{ value: "Japanese", label: "Japanese", flag: "🇯🇵" },
		{ value: "Korean", label: "Korean", flag: "🇰🇷" },
		{ value: "Russian", label: "Russian", flag: "🇷🇺" },
		{ value: "Portuguese", label: "Portuguese", flag: "🇵🇹" },
		{ value: "Turkish", label: "Turkish", flag: "🇹🇷" },
	];
}

/**
 * Get a language option by value
 */
export function getLanguageOptionByValue(
	value: string,
): DropdownOption | undefined {
	return getLanguageOptions().find((option) => option.value === value);
}
